export default "__VITE_ASSET__BEK6JVbP__"